/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_StudioInputs */

const en_for_whom_studio = /** @type {(inputs: For_Whom_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio and club`)
};

const pl_for_whom_studio = /** @type {(inputs: For_Whom_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio i klub`)
};

/**
* | output |
* | --- |
* | "Studio and club" |
*
* @param {For_Whom_StudioInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_studio = /** @type {((inputs?: For_Whom_StudioInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_StudioInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_studio(inputs)
	return en_for_whom_studio(inputs)
});